export default __webpack_public_path__ + "static/2022 StM Annual School Report-a4bc8397f6af93ff173d11065a32203a.pdf";